var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible !== false)?_c('button',{class:{'small': _vm.small === true, 'raised': _vm.raised},attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[(_vm.icon)?_c('i',{staticClass:"fa fa-color",class:[_vm.icon, _vm.iconColor],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.model)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b06864c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Widget/PsButton.vue
// module id = null
// module chunks = 